import { useLayoutEffect } from 'react';
var index = useLayoutEffect;
export { index as default };